/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocietyForm
 */
export interface SocietyForm {
    /**
     * 
     * @type {string}
     * @memberof SocietyForm
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof SocietyForm
     */
    internalIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof SocietyForm
     */
    readableName: string;
    /**
     * JSON list of fields
     * @type {object}
     * @memberof SocietyForm
     */
    fieldsList?: object | null;
    /**
     * 
     * @type {object}
     * @memberof SocietyForm
     */
    readonly prepopulatedData?: object;
}

/**
 * Check if a given object implements the SocietyForm interface.
 */
export function instanceOfSocietyForm(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;

    return isInstance;
}

export function SocietyFormFromJSON(json: any): SocietyForm {
    return SocietyFormFromJSONTyped(json, false);
}

export function SocietyFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocietyForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalIdentifier': json['internal_identifier'],
        'readableName': json['readable_name'],
        'fieldsList': !exists(json, 'fields_list') ? undefined : json['fields_list'],
        'prepopulatedData': !exists(json, 'prepopulated_data') ? undefined : json['prepopulated_data'],
    };
}

export function SocietyFormToJSON(value?: SocietyForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internal_identifier': value.internalIdentifier,
        'readable_name': value.readableName,
        'fields_list': value.fieldsList,
    };
}

